module.exports = __webpack_public_path__ + "static/media/inistgram.addda643.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Register/inistgram.png
// module id = 626
// module chunks = 0